import React, { useContext } from 'react';
import { Button, Steps } from 'antd';
import './styles.less';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import steps from '../../../steps';
import { EnrollmentContext } from '../../../../../providers/EnrollmentContextProvider';
import Text from '../../../../../components/common/Text';

const EnrollmentLegalProgressStepper = ({ onBack }) => {
  const { currentStepEnrollmentLegal, currentStepEnrollmentLegalIndex } = useContext(
    EnrollmentContext
  );

  return (
    <div className="enrollment-legal-steps">
      {currentStepEnrollmentLegalIndex > 0 && (
        <Button type="link" className="enrollment-legal-steps-back-button" onClick={onBack}>
          <ArrowLeftOutlined />{' '}
          <Text underline className="enrollment-legal-steps-back-button__label">
            Volver atrás
          </Text>
        </Button>
      )}
      <h2 className="enrollment-legal-steps__title">{currentStepEnrollmentLegal.title}</h2>
      <p className="enrollment-legal-steps__description">
        {currentStepEnrollmentLegal.description}
      </p>
      <Steps direction="vertical" current={currentStepEnrollmentLegalIndex}>
        {steps.map((step) => (
          <Steps.Step key={step.title} title={step.title} />
        ))}
      </Steps>
    </div>
  );
};

EnrollmentLegalProgressStepper.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default EnrollmentLegalProgressStepper;
